import { api } from '@/services';

export interface AlterarTipoItemPayload {
  CNPJ_Contribuinte: string;
  TipoItem: string;
  Produtos: string[];
}

export interface AlterarSegmentoPayload {
  CNPJ_Contribuinte: string;
  Segmento: string;
  Produtos: string[];
}

export async function alterarTipoItem(
  payload: AlterarTipoItemPayload
): Promise<{ status: { resultado: boolean; mensagem: string } }> {
  return api.post('Produto/AlterarTipoItem', payload);
}

export async function alterarSegmento(
  payload: AlterarSegmentoPayload
): Promise<{ status: { resultado: boolean; mensagem: string } }> {
  return api.post('Produto/AlterarSegmento', payload);
}
